import { Action } from '@ngrx/store';
import { BookingReportState, INITIAL_BOOKING_REPORT_STATE } from './booking-report.state';
import {
  BookingReportActionTypes,
  BookingReportLoadCalendarItemsSuccessAction,
  BookingReportLoadTableItemsSuccessAction,
  BookingReportUpdateCalendarFiltersAction,
  BookingReportUpdateTableFiltersAction,
  BookingReportUpdateViewTypesAction,
} from './booking-report.actions';
import {
  BookingReportCalendarFilter,
  BookingReportTableFilter,
  BookingReportViewType,
} from '../booking-report-filters/booking-report-filters.models';

export const bookingReportReducer = (
  state: BookingReportState = INITIAL_BOOKING_REPORT_STATE,
  action: Action,
): BookingReportState => {
  switch (action.type) {
    case BookingReportActionTypes.UpdateViewTypes: {
      const viewTypes = (action as BookingReportUpdateViewTypesAction).payload;

      return Object.assign({}, state, {
        view: viewTypes.view,
        calendarViewType: viewTypes.calendarType,
      } as BookingReportState);
    }
    case BookingReportActionTypes.UpdateCalendarFilters: {
      const filter = (action as BookingReportUpdateCalendarFiltersAction).payload;

      return Object.assign({}, state, {
        calendarFilters: filter,
        tableFilters: null,
      } as BookingReportState);
    }
    case BookingReportActionTypes.UpdateTableFilters: {
      const filter = (action as BookingReportUpdateTableFiltersAction).payload;

      return Object.assign({}, state, {
        tableFilters: filter,
        calendarFilters: null,
      } as BookingReportState);
    }
    case BookingReportActionTypes.LoadCalendarItemsSuccess: {
      const calendarItems = (action as BookingReportLoadCalendarItemsSuccessAction).payload;

      return Object.assign({}, state, {
        calendarItems: calendarItems,
      } as BookingReportState);
    }
    case BookingReportActionTypes.LoadTableItemsSuccess: {
      const tableResult = (action as BookingReportLoadTableItemsSuccessAction).payload;

      return Object.assign({}, state, {
        tableItems: tableResult.items,
        tableFilters: { ...state.tableFilters, pageNumber: tableResult.pageNumber ?? state.tableFilters.pageNumber },
      } as BookingReportState);
    }
    case BookingReportActionTypes.ClearBookingReportFilters: {
      const tableFilters =
        state.view === BookingReportViewType.Calendar
          ? INITIAL_BOOKING_REPORT_STATE.tableFilters
          : new BookingReportTableFilter();

      const initialCalendarFilters =
        state.view === BookingReportViewType.Calendar ? INITIAL_BOOKING_REPORT_STATE.calendarFilters : null;
      const calendarFilters = Object.assign(
        new BookingReportCalendarFilter(),
        initialCalendarFilters,
        {startDate: state.calendarFilters.startDate, endDate: state.calendarFilters.endDate});

      return Object.assign({}, state, {
        tableFilters: tableFilters,
        calendarFilters: calendarFilters,
      } as BookingReportState);
    }
    case BookingReportActionTypes.ResetBookingReportStore: {
      return INITIAL_BOOKING_REPORT_STATE;
    }
    default: {
      return state;
    }
  }
};
